import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check } from "lucide-react";
import api from "../lib/api";

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const orderId = params.get("order_id");
  const [order, setOrder] = useState(null);
  const [status, setStatus] = useState(orderId ? "loading" : "error");

  useEffect(() => {
    if (!orderId) return;
    api
      .get(`/orders/lookup/${orderId}`)
      .then(({ data }) => {
        setOrder(data);
        setStatus(data.payment_status === "paid" ? "paid" : "pending");
      })
      .catch(() => setStatus("error"));
  }, [orderId]);

  return (
    <div className="pt-40 pb-24 min-h-[70vh]">
      <div className="max-w-2xl mx-auto px-6 md:px-12 text-center">
        {status === "loading" && (
          <>
            <div className="label-eyebrow mb-4">Processing</div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter">
              Confirming your order…
            </h1>
          </>
        )}
        {status === "paid" && order && (
          <>
            <div className="w-16 h-16 mx-auto bg-[#111] text-white rounded-full flex items-center justify-center">
              <Check size={28} />
            </div>
            <h1 className="mt-8 font-display text-4xl sm:text-5xl font-extrabold tracking-tighter">
              Thank you.
            </h1>
            <p className="mt-6 text-[#666]" data-testid="order-confirmed">
              Your order has been placed. A confirmation will arrive shortly.
            </p>
            <div className="mt-10 text-left border border-[#e5e5e5] p-6">
              <div className="label-eyebrow mb-3">Order</div>
              <div className="text-sm text-[#666]">
                #{order.id.slice(0, 8).toUpperCase()}
              </div>
              <ul className="mt-4 space-y-2 text-sm">
                {order.items.map((it, idx) => (
                  <li key={idx} className="flex justify-between">
                    <span>
                      {it.name} · Size {it.size}{it.color ? ` · ${it.color}` : ""} × {it.quantity}
                    </span>
                    <span>₹{it.line_total.toFixed(2)}</span>
                  </li>
                ))}
              </ul>
              <div className="flex justify-between font-display font-bold mt-4 pt-4 border-t border-[#e5e5e5]">
                <span>Total</span>
                <span>₹{order.total.toFixed(2)}</span>
              </div>
            </div>
            <Link
              to="/shop"
              className="inline-block mt-10 bg-[#111] text-white px-8 py-4 text-sm font-medium hover:bg-[#333]"
            >
              Continue shopping
            </Link>
          </>
        )}
        {(status === "pending" || status === "error") && (
          <>
            <div className="label-eyebrow mb-4">Payment status</div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tighter">
              We're still confirming your payment.
            </h1>
            <p className="mt-6 text-[#666]">
              If you were charged, your order will appear in your account shortly. Otherwise, try
              again.
            </p>
            <Link
              to="/checkout"
              className="inline-block mt-10 bg-[#111] text-white px-8 py-4 text-sm font-medium hover:bg-[#333]"
            >
              Return to checkout
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
